type TableInitializationTracker = {
  isInitialized: boolean;
};

export const leadTableTracker: TableInitializationTracker = {
  isInitialized: false,
};
